import { Box } from '@wix/design-system';
import React from 'react';
export const ProductCardWrapper = ({ dataHook, className, borderColor, borderWidth, borderRadius, children, height, cursor, }) => {
    return (React.createElement(Box, { dataHook: dataHook, className: className, height: height, width: "100%", background: borderColor, padding: borderWidth, borderRadius: borderRadius, position: "relative", cursor: cursor }, children));
};
//# sourceMappingURL=ProductCardWrapper.js.map